
module.exports = function()
{
    this.jsonrpc = null;
    this.method = null;
    this.id = null;
    this.params = new Object();
}